import { Reducer } from 'redux'
import { IKoppelingenVestigingenState } from '../interfaces'
import {
  KoppelingenVestigingenActions,
  Actions,
} from '../actions/koppelingenVestigingenAction'

const initialState: IKoppelingenVestigingenState = {
  loading: false,
  vestiging: undefined,
  koppelingen: [],
  foutmelding: undefined,
}

export const koppelingenVestigingenReducer: Reducer<
  IKoppelingenVestigingenState,
  KoppelingenVestigingenActions
> = (state = initialState, action) => {
  switch (action.type) {
    case Actions.GetDataRequest:
      return {
        ...state,
        loading: true,
        selectie: action.payload,
        foutmelding: null,
      }
    case Actions.GetDataResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.errorMessage,
        koppelingen: action.success ? action.payload : [],
      }

    case Actions.ClearDataRequest:
      return { ...state, loading: true, foutmelding: null }
    case Actions.ClearDataResponse:
      return {
        ...state,
        loading: false,
        koppelingen: [],
        foutmelding: action.success ? action.payload : action.errorMessage,
      }

    case Actions.SetWarehouseAction:
      return { ...state, koppelingen: [], vestiging: action.payload }

    default:
      // The following line guarantees that every action in the KnownAction union has been covered by a case above
      neverReached(action)
  }
  return state
}

// tslint:disable-next-line:no-empty
const neverReached = (never: never) => {}
